import $ from 'jquery';
import EventBus from './EventBus';

const OPTIONAL_CONSENT_CATEGORIES = ['preferences', 'statistics', 'marketing'];

function notifyCmConsentListeners(signals) {
  if (!signals) {
    return;
  }
  (window.__cmConsentListeners || []).forEach((callback) => {
    callback(signals);
  });
}

function notifyFromConsentResponse(data) {
  if (data && data.google_consent) {
    notifyCmConsentListeners(data.google_consent);
  }
}

function grantedCategoriesFromConsentData(data) {
  if (!data) {
    return [];
  }

  return OPTIONAL_CONSENT_CATEGORIES.filter((category) => data[category]);
}

function shouldActivateScript(script, grantedCategories) {
  const category = script.getAttribute('data-consent-category');

  if (category) {
    return grantedCategories.includes(category);
  }

  // Untagged legacy scripts (GTM/gtag): activate after Accept / any optional grant.
  return grantedCategories.length > 0;
}

function activateScript(inertScript) {
  const liveScript = document.createElement('script');
  liveScript.type = 'text/javascript';

  Array.from(inertScript.attributes).forEach((attribute) => {
    if (attribute.name === 'type' || attribute.name === 'data-consent-category') {
      return;
    }

    if (attribute.name === 'async') {
      liveScript.async = true;
      return;
    }

    liveScript.setAttribute(attribute.name, attribute.value);
  });

  if (inertScript.async) {
    liveScript.async = true;
  }

  if (inertScript.textContent) {
    liveScript.text = inertScript.textContent;
  }

  inertScript.after(liveScript);
  inertScript.remove();
}

function recreateScripts(grantedCategories = []) {
  document.querySelectorAll("script[type='text/plain']").forEach((script) => {
    if (shouldActivateScript(script, grantedCategories)) {
      activateScript(script);
    }
  });
}

function isConsentCookiesUrl(url) {
  return Boolean(url && /\/cookies\/(accept|adjust|revoke)/.test(url));
}

function shouldActivateScriptsForUrl(url) {
  return /\/cookies\/(accept|adjust)/.test(url);
}

function handleCookiesAjaxSuccess(xhr, settings) {
  if (!settings || !isConsentCookiesUrl(settings.url)) {
    return;
  }

  let data;
  try {
    data = JSON.parse(xhr.responseText);
  } catch (_error) {
    return;
  }

  notifyFromConsentResponse(data);

  if (shouldActivateScriptsForUrl(settings.url)) {
    recreateScripts(grantedCategoriesFromConsentData(data));
  }
}

// Consent Studio mounts <section class="cs-banner cs-banner--original"> via GTM.
// Bottom-sheet layout (and Zendesk/footer lift) only applies on mobile.
function consentStudioBannerHeight() {
  if (!window.matchMedia('(max-width: 767px)').matches) {
    return 0;
  }

  const banner = document.querySelector('.cs-banner');
  if (!banner) {
    return 0;
  }

  const style = window.getComputedStyle(banner);
  if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
    return 0;
  }

  const rect = banner.getBoundingClientRect();
  if (rect.height < 1) {
    return 0;
  }

  return $(banner).outerHeight() || 0;
}

// .mobile-slide-up-container uses CSS bottom:-90px / &.show{bottom:0}; clear inline when hidden.
function mobileCtaBottomStyle(shown, bannerHeight) {
  if (!shown) {
    return '';
  }

  return `${bannerHeight}px`;
}

$(function () {
  let resizeListeners = [];
  const bookingFloatingFooter = $('.v2-booking-floating-footer');
  const mobileCta = $('.mobile-cta');

  $(document).ajaxSuccess(function (_event, xhr, settings) {
    handleCookiesAjaxSuccess(xhr, settings);
  });

  $(window).on('resize', function () {
    resizeListeners.forEach((fn) => fn());
  });

  function noticeHeight() {
    return consentStudioBannerHeight();
  }

  function noticeWithBookingFloatingFooterHeight() {
    let height = noticeHeight();

    if (bookingFloatingFooter.is(':visible')) {
      height += bookingFloatingFooter.height() || 0;
    }

    if (mobileCta.length && mobileCta.hasClass('show') && mobileCta.is(':visible')) {
      height += mobileCta.outerHeight() || 0;
    }

    return height;
  }

  // Custom launcher is server-rendered; do not wait for async zE stub.
  if ($('#zendesk-launcher').length) {
    var adjustZendeskLauncher = () => {
      const height = noticeWithBookingFloatingFooterHeight();
      $('#zendesk-launcher').css('bottom', height + 20 + 'px');
    };

    const adjustZendeskWhenExists = () => {
      const checkExist = setInterval(() => {
        if ($('#zendesk-launcher').is(':visible')) {
          adjustZendeskLauncher();
          clearInterval(checkExist);
        }
      }, 100);

      // Avoid an endless poll if the launcher stays hidden (e.g. mobile chat_hidden?).
      setTimeout(() => clearInterval(checkExist), 60000);
    };

    resizeListeners.push(adjustZendeskLauncher);
    adjustZendeskWhenExists();
  }

  const workPage = $('.work-page');
  if (workPage.length) {
    function adjustBookingFloatingFooter() {
      const height = noticeHeight();
      bookingFloatingFooter.attr('style', `bottom: ${height}px !important;`);
      workPage.attr('style', `margin-bottom: ${height}px !important;`);
    }

    resizeListeners.push(adjustBookingFloatingFooter);
    adjustBookingFloatingFooter();

    if (typeof adjustZendeskLauncher === 'function') {
      EventBus.on('basket:end-fetching-quote', adjustZendeskLauncher);
    }
  }

  if (mobileCta.length) {
    function adjustMobileCta() {
      mobileCta.css('bottom', mobileCtaBottomStyle(mobileCta.hasClass('show'), noticeHeight()));
      if (typeof adjustZendeskLauncher === 'function') {
        adjustZendeskLauncher();
      }
    }

    resizeListeners.push(adjustMobileCta);
    adjustMobileCta();
    // .show is toggled on scroll by floating_cta_button.coffee.js
    $(window).on('scroll', adjustMobileCta);
  }

  const reflowBottomOffsets = () => resizeListeners.forEach((fn) => fn());

  // Banner hide is often async after this event — reflow now and after paint.
  const reflowAfterConsentStudioUpdate = () => {
    reflowBottomOffsets();
    requestAnimationFrame(() => {
      reflowBottomOffsets();
      setTimeout(reflowBottomOffsets, 100);
    });
  };

  window.addEventListener('consent-studio__updated', reflowAfterConsentStudioUpdate);

  // GTM injects .cs-banner after DOM ready; Accept/Reject may hide it via class/style.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver((mutations) => {
      const csBannerChanged = mutations.some((mutation) => {
        if (mutation.type === 'attributes') {
          return Boolean(
            mutation.target.classList?.contains('cs-banner') || mutation.target.closest?.('.cs-banner'),
          );
        }

        return Array.from(mutation.addedNodes)
          .concat(Array.from(mutation.removedNodes))
          .some(
            (node) =>
              node.nodeType === 1 &&
              (node.classList?.contains('cs-banner') || node.querySelector?.('.cs-banner')),
          );
      });

      if (csBannerChanged) {
        reflowBottomOffsets();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
  }
});

export {
  OPTIONAL_CONSENT_CATEGORIES,
  consentStudioBannerHeight,
  grantedCategoriesFromConsentData,
  handleCookiesAjaxSuccess,
  mobileCtaBottomStyle,
  notifyCmConsentListeners,
  notifyFromConsentResponse,
  recreateScripts,
};
